module.exports = __webpack_public_path__ + "img/medical_transfer.a6cf9f9e.svg";